
/**
 * @param {String} title 
 * e.g. "Sonic Free Games" -> "sonic-free-games"
 */
export const titleToId = (title) => {
  return title.replace(/\s+/g, '-').toLowerCase();
}


/**
   * Creates a string that can be used for dynamic id attributes
   * Example: "id-so7567s1pcpojemi"
   * @returns {string}
   */
export const uniqueId = () => {
  return 'id-' + Math.random().toString(36).substr(2, 16);
};

/**
   * get string and replace previous year with current;
   * @returns {string}
   */
export const updateYearToCurrent = (str) => {
  const currentYear = (new Date()).getFullYear();
  const previousYear = (new Date()).getFullYear() - 1;
  return str.replace(previousYear, currentYear);
};


/**
  * get string and replace previous year with current;
  * @returns {string}
*/
export const findResizedImage = (originalImageUrl, resizedImames) => {
  const originalName = originalImageUrl.split('/').pop();
  const resized = resizedImames.find((item) => {
    return item.node.resize.originalName === originalName
  })
  if (resized) {
    return resized.node.resize.src
  }
  return originalImageUrl;
};



/**
  * 
  * @returns {string}
*/
export const getWebpImage = (jppImageUrl) => {
  return jppImageUrl.replace('.jpg', '.webp').replace('.jpeg', '.webp').replace('/img/', '/img/webp-generated/');
};




// WEBPACK FOOTER //
// ./src/utils/index.js